export default "https://sdk.cotreat.ai/smile-2cd33ebe.svg";